import { injectable } from "inversify";
import databaseInstance from "../../index";

@injectable()
export class MailingService {
  private dbInstance: any = databaseInstance;

  private static instance: MailingService;

  constructor() {
    MailingService.instance = this;
  }

  public static getInstance() {
    if (!MailingService.instance) {
      MailingService.instance = new MailingService();
    }
    return MailingService.instance;
  }

  public getCustomEmailsList: (
    groupId: number,
  ) => Promise<void> = (groupId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(`/groups/${groupId}/custom-emails`)
        .then((response: any) => resolve(response))
        .catch((error: any) => reject(error))
    });
  };

  public updateCustomEmail: (
    groupId: number,
    customEmailId: number,
    customEmailData: any,
  ) => Promise<void> = (groupId, customEmailId, customEmailData) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
      .put(`/groups/${groupId}/custom-emails/${customEmailId}`, customEmailData)
      .then((response: any) => resolve(response))
        .catch((error: any) => reject(error))
    })
  }

  public createCustomEmail: (
    groupId: number,
    customEmailData: any,
  ) => Promise<void> = (groupId, customEmailData) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
      .post(`/groups/${groupId}/custom-emails`, customEmailData)
        .then(() => resolve())
        .catch((error: any) => reject(error))
    })
  }
}
